<div class="main-bg-box container">
    <h1 class="heading-text">
        Privacy Policy
    </h1>
    <title>Privacy Policy - Vidhema Technologies</title>
    <div class="date-box">
        <h2 class="sub-heading">
            Effective date: [20 July 2023]
        </h2>
        
        <p>
            At Vidhema Technologies, your privacy is of utmost importance to us. This Privacy Policy aims to provide you with a clear understanding of how we handle your personal information when you engage with our website, products, and services. By accessing or using our website or services, you signify your consent to the practices described in this Privacy Policy
        </p>
    </div>
  
    <ol >
       <p class="ol-value-design">
        Information we collect:
       </p>
        <li>
            Personal Information: When you interact with us, we may collect personal information that you voluntarily provide, such as your name, email address, phone number, postal address, and any other information you share with us through our contact forms, account registration, or while communicating with our customer support team. We may also collect payment information if you make a purchase from us.
        </li>
        <li>
            
 Non-Personal Information: In addition to personal information, we may automatically collect non-personal information when you access or use our website. This information may include your IP address, browser type, operating system, device information, and details about your interactions with our website, such as the pages visited, time spent on each page, and referring URL.

        </li>
    </ol>
    <ol>
        <p class="ol-value-design">
            Use of information:

        </p>
        <li>
             Communication: We may use your contact details to communicate with you about our products, services, updates, and promotional materials. You can choose to opt-out of receiving such communications at any time.
        </li>
        <li>
             Website Improvement: The non-personal information we gather helps us analyze user behavior, identify trends, and improve the performance, design, and content of our website to enhance user experience.
        </li>
        <li> Legal Compliance: In some cases, we may need to use and disclose your personal information to comply with applicable laws, regolations, legal processes, or enforceable governmental requests.


        </li>
        
    </ol>
    <ol>
        <p class="ol-value-design">
            Data retention:
        </p>
        <li>
            We retain your personal information only for as long as necessary to folfill the purposes outlined in this Privacy Policy or as required by applicable laws and regolations. When the information is no longer needed, we will securely delete, anonymize, or aggregate it
        </li>
    </ol>
    <ol>
        <p class="ol-value-design">
            Sharing of information:
        </p>
        <li>
            We do not sell, trade, or rent your personal information to third parties for their marketing purposes. However, we may share your information with trusted third-party service providers who assist us in operating our business and delivering services to you. These third-party providers are bound by strict confidentiality agreements and are prohibited from using your information for any purpose other than assisting us.

        </li>
    </ol>
    <ol>
        <p class="ol-value-design">
            Cookies and similar technologies:
        </p>
        <li>
            We may use cookies, web beacons, and similar technologies to enhance your experience on our website. Cookies help us remember your preferences and streamline your interactions. You have the option to modify your browser settings to manage cookies or decline their usage, but this may impact certain features and functionalities of our website.
        </li>
    </ol>
    <ol>
        <p class="ol-value-design">
            Data security
        </p>
        <li>
            We understand the importance of safeguarding your personal information and have implemented reasonable security measures to protect it from unauthorized access, disclosure, alteration, or destruction. Our employees and third-party service providers are bound by strict confidentiality agreements, and access to personal information is restricted to those who need it to perform their duties.
        </li>
        <li>
            While we take appropriate measures, please be aware that no method of transmission over the internet or electronic storage is entirely secure. Therefore, we cannot guarantee absolute security, and we urge you to take appropriate precautions when sharing personal information online.
        </li>
    </ol>
    <ol>
        <p class="ol-value-design">
            Third-party links:
        </p>
        <li>
            Our website may contain links to third-party websites or services that are not operated or controlled by us. We are not responsible for the privacy practices or content of these third-party sites. We recommend reviewing their respective privacy policies before providing any personal information on their platforms.
        </li>
    </ol>
    <ol>
        <p class="ol-value-design">
            Children's privacy:
        </p>
        <li>
            Our services are not intended for individuals under the age of 13. We do not knowingly collect personal information from children. If we become aware that we have inadvertently collected personal information from a child under 13, we will take prompt steps to delete such data from our records.
        </li>
    </ol>
    <ol>
        <p class="ol-value-design">
            Changes to the Privacy Policy:
        </p>
        <li>
            We may update this Privacy Policy periodically to reflect changes in our practices or for legal or regolatory reasons. When we make significant changes, we will notify you through prominent notice on our website or by email if you have provided your consent to receive communications from us.
        </li>
    </ol>
    <ol>
        <p class="ol-value-design">
            Contact us:

        </p>
        <li>
            If you have any questions, concerns, or requests regarding this Privacy Policy or your personal information, please do not hesitate to contact us using the following details:
        </li>
    </ol>

    <div class="address-box">
        <p>
            Vidhema Technologies Pte Ltd
        </p>
        <p>
            68 CIRColAR ROAD, 
    
        </p>
        <p>
            #02-01, Singapore, Singapore 049422
        </p>
        <p>
            <a>
                sales@vidhema.com
            </a>
        </p>
        <p>
            <a>
                +65 80151152
            </a>
        </p>
    </div>
   
    <p>
        By using our website or services, you acknowledge that you have read and understood this Privacy Policy and consent to the collection, use, and disclosure of your personal information as described herein. We are committed to respecting your privacy rights and maintaining the confidentiality and security of your personal information. Thank you for choosing Vidhema Technologies. 
    </p>

</div>